import { useCallback, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';

const POLL_INTERVAL_MS = 5 * 60 * 1000;

export function useVersionCheck() {
	const hasNotified = useRef(false);

	const checkVersion = useCallback(async () => {
		if (hasNotified.current) return;

		try {
			const res = await fetch(`/version.json?t=${Date.now()}`);
			if (!res.ok) return;

			const data = await res.json();
			if (data.version && data.version !== __APP_VERSION__) {
				hasNotified.current = true;
				toast.info(
					<div className="flex flex-col gap-1 mr-3">
						<span className="font-medium">New version available</span>
						<button
							type="button"
							className="text-md underline text-left hover:opacity-80"
							onClick={() => window.location.reload()}
						>
							Refresh to update
						</button>
					</div>,
					{
						autoClose: false,
						closeOnClick: false,
						toastId: 'version-update',
						position: 'bottom-center',
					}
				);
			}
		} catch {
			// Network errors are expected when offline — silently ignore
		}
	}, []);

	useEffect(() => {
		// if (import.meta.env.DEV) return;

		checkVersion();
		const id = setInterval(checkVersion, POLL_INTERVAL_MS);
		return () => clearInterval(id);
	}, [checkVersion]);
}
